import { Component, OnInit, Input } from '@angular/core';
import { FrequentQuestionsService } from "./frequent-questions.service";
import { CommonUtilitiesService } from '../common-utilities.service';
import { constants } from '../constants';
@Component({
  selector: 'app-frequent-questions',
  templateUrl: './frequent-questions.component.html',
  styleUrls: ['./frequent-questions.component.scss']
})
export class FrequentQuestionsComponent implements OnInit {
  @Input() optionSelect:string;
  listFqs = null;
  isShowModal = false;
  modalTitle = "";
  modalContent = "";
  constructor(private frequentQuestionsService : FrequentQuestionsService, public LANG: CommonUtilitiesService) { 
    
  }
    /**
   * Description: Método que llama el servicio web que obtiene las preguntas frecuentes
   * Autor: Steven Sterling
   * @param N/A
   * @return N/A
   */
  ngOnInit() {
      this.frequentQuestionsService.getFQSList({ "category": this.optionSelect }).subscribe((dataInfo => {

      if(dataInfo['responseCode'] ==  constants.SUCCESS_WS_RESPONSE_CODE){
        this.listFqs = dataInfo['obj'];
      }else{
        this.modalTitle = "Error: ";
        this.modalContent =  "No se ha podido establecer la conexión con el servidor.";
        this.isShowModal = true;
      }

      }),
      (err) => {
        this.modalTitle = "Error: " + err.code;
        this.modalContent =  "No se ha podido establecer la conexión con el servidor.";
        this.isShowModal = true;
      });
      
  }
}
